import React from 'react'
import './Gurudev_content.css'

import parse from "html-react-parser"

const Gurudev_content = ({ content }) => {
    return (
        <>
            <section className='Gurudev_content_sec'>
                <div className='container'>
                    <div className='Gurudev_content'>
                        <div className='row'>
                            <div className='col-lg-8 col-sm-10  mx-auto'>
                                <h1 className='gurutitle'>{content?.name || " "}</h1>
                                <p className='gurucont'>{parse(content?.description || " ")}</p>

                            </div>
                            {/* <div className='col-lg-8 col-sm-10  mx-auto'>
                                <h1 className='gurutitle'>Gurudev's</h1>
                                <p className='gurucont'>Ability to shape language into a tool towards self-realization has unveiled
                                    the deeper intricacies of both the human and the larger cosmos. His books offer life-altering perspectives & a taste of existence the way it is. Those eager for a daily measure of Gurudev's wisdom find it in the
                                    Mystic Quotes, Spiritual Truth Blog, and weekly Gurudev Spot.
                                </p>

                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Gurudev_content